import { Installation } from "../Installation";
import { Configuration } from "./Configuration";

export class ConfigurationHistory {
    id: number;
    name: string;
    dateTime: Date;
    installations: Array<Installation>;
    configuration: Configuration;

    public parse(obj: any) {
        if (obj.Id != null) this.id = obj.Id;
        if (obj.Name) this.name = obj.Name;
        if (obj.DateTime) this.dateTime = obj.DateTime;
        if (obj.Installations) {
            this.installations = new Array<Installation>();
            obj.Installations.forEach((inst) => {
                let i = new Installation();
                i.parse(inst);
                this.installations.push(i);
            });
        }
        if (obj.Configuration) {
            this.configuration = new Configuration();
            this.configuration.parse(obj.Configuration);
        }
    }
}
